import React from "react";

import PropTypes from "prop-types";
import "./styles.scss";

const MenuItem = ({ text, icon, selected, disabled, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`menuitem ${selected && "menuitem-selected"} ${
        disabled && "menuitem-disabled"
      }`}>
      {icon && <div className={"icon"}>{icon}</div>}
      <p>{text}</p>
    </div>
  );
};

MenuItem.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default MenuItem;
